<template>
    <div>
        <!-- 荣誉资质 -->
        <div  class="ryzz_box_big">
            <div class="ryzz_box">
                <p class="ryzz_box_left">
                    <img src='../../images/ryzz.png'/>
                    <span>荣誉资质</span>
                </p>
                <ul class="ryzz_box_right">
                    <li style="margin-top: 5px;width:31%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>安妮股份（002235.SZ）全资子公司</span>
                    </li>
                    <li style="margin-top: 5px;width:35%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>版权保护中心/互联网法院/国家授时中心合作伙伴</span>
                    </li>
                    <li style="margin-top: 5px;width:33%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>中国版权保护中心联合创新实验室共建方</span>
                    </li>
                    <li style="width:31%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>版权区块链联盟主要发起单位及理事长单位</span>
                    </li>
                    <li style="width:35%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>中国区块链技术和产业发展论坛副理事长单位</span>
                    </li>
                    <li style="width:33%">
                        <img src="../../images/ryzz_list.png"/>
                        <span>中国反侵权假冒创新战略联盟联席理事长单位</span>
                    </li>
                </ul>
            </div>
        </div>
        
    </div>
</template>

<script>
    

    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'indextwo',
        components:{
            
        },
        data(){
            return {
               
            }
        },

        methods:{
        }

    }
</script>

<style scoped lang="less">
//荣誉资质
    .ryzz_box_big{
        width: 1217px;
        height: 110px;
        margin: 34px auto auto auto;
    }
    .ryzz_box{
        background: url('../../images/ryzz_bg.png') 100% 100% no-repeat;
        display: flex;
        padding:23px 0;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background-size: cover;
        .ryzz_box_left{
            width: 162px;
            border-right:1px solid rgba(214,172,109,0.18);
            text-align: center;
            img{
                width: 47px;
                height: 40px;
                display: block;
                margin-bottom: 4px;
                margin: auto;
            }
            span{
                font-size: 16px;
                color:#DBAF6D;
                line-height: 24px;
                // color: angular-gradient(90deg, #EAD2AF 0%, #DBAF6D 100%);
            }
        }
        .ryzz_box_right{
            -webkit-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            font-size: 14px;
            color: #B6915A;
            line-height: 20px;
            padding-left: 54px;
            box-sizing: border-box;
            img{
                width: 15px;
                height: 14px;
                display: inline-block;
                // margin-right: 4px;
                position: absolute;
                left: 0;
                top: 3px;
            }
            li{
                // width: 33.33%;
                float: left;
                margin-top: 14px;
                position: relative;
                padding-left: 20px;
            }
        }
    }
</style>